// 1:未开通视频彩铃功能。
// 2：已开通视频彩铃功能，但视频彩铃播放功能处于关闭状态。
/// /3：已开通视频彩铃功能，且视频彩铃播放功能处于开启状态。
export var RingStatusDic;
(function (RingStatusDic) {
    RingStatusDic["NoRingTone"] = "1";
    RingStatusDic["RingToneOffPlay"] = "2";
    RingStatusDic["RingToneOnPlay"] = "3";
})(RingStatusDic || (RingStatusDic = {}));
// 实现支付类型对象
export const RingStatusType = {
    ENUM: {
        [RingStatusDic.NoRingTone]: '未开通视频彩铃功能',
        [RingStatusDic.RingToneOffPlay]: '已开通视频彩铃功能，但视频彩铃播放功能处于关闭状态',
        [RingStatusDic.RingToneOnPlay]: '已开通视频彩铃功能，且视频彩铃播放功能处于开启状态'
    },
    NoRingTone: RingStatusDic.NoRingTone,
    RingToneOffPlay: RingStatusDic.RingToneOffPlay,
    RingToneOnPlay: RingStatusDic.RingToneOnPlay
};
